import {config} from '@gisatcz/ptr-core';

/**
 * APP SPECIFIC DEFAULT VALUES
 */
import appDefaults from './appDefaults';

export default config(appDefaults);
